import { ConsultationForm } from "@/components/ConsultationForm";
import { SectionLabel } from "@/components/home/SectionLabel";

export function ContactCta() {
    return (
        <section id="contact" className="bg-sage text-cream relative z-10">
            <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-24 grid lg:grid-cols-[0.9fr_1.1fr] gap-14">
                <div>
                    <SectionLabel className="text-terracotta">Get started</SectionLabel>
                    <h2 className="font-heading text-4xl sm:text-5xl tracking-tight mt-4">
                        Ready to stop chasing claims?
                    </h2>
                    <p className="text-cream/70 leading-relaxed mt-6 max-w-md">
                        Tell us about your practice and we'll show you what we can take off your
                        plate.
                    </p>
                </div>
                <div>
                    <ConsultationForm variant="dark" />
                </div>
            </div>
        </section>
    );
}
